<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <loading v-if="! showContent"></loading>
                <h2 class="titulo" v-if="showContent">{{ title }}</h2>
                <div class="redes_sociais" v-if="showContent">
                    <loading v-if="! showContent"></loading>
                    <a :href="item.url" v-for="item in items" v-if="item.url" target="_blank">
                        <i :class="getIcon(item)" aria-hidden="true"></i>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>
<script type="text/javascript">
    import { get } from '../../helpers/api';
    import Loading from '../common/Loading.vue';

    export default {
        components: {
            Loading
        },
        props: ['bloco'],
        data() {
            return {
                title: 'Redes Sociais',
                showContent: true,
                items: [],
                icons: [
                    {
                        type: 'instagram',
                        icon: 'fa-instagram'
                    },
                    {
                        type: 'facebook',
                        icon: 'fa-facebook-f'
                    },
                    {
                        type: 'twitter',
                        icon: 'fa-twitter'
                    },
                    {
                        type: 'soundCloud',
                        icon: 'fa-soundcloud'
                    },
                    {
                        type: 'youtube',
                        icon: 'fa-youtube'
                    },
                    {
                        type: 'google',
                        icon: 'fa-google-plus-g'
                    },
                    {
                        type: 'whatsapp',
                        icon: 'fa-whatsapp'
                    },
                    {
                        type: 'blog',
                        icon: 'fa-rss'
                    },
                    {
                        type: 'myspace',
                        icon: 'fa-share-alt'
                    },
                    {
                        type: 'flickr',
                        icon: 'fa-flickr'
                    },
                    {
                        type: 'lastfm',
                        icon: 'fa-lastfm'
                    },
                    {
                        type: 'viber',
                        icon: 'fab fa-viber'
                    },
                    {
                        type: 'snapchat',
                        icon: 'fa-snapchat-ghost'
                    }
                ]
            }
        },
        created() {
            if (this.bloco.nome) {
                this.title = this.bloco.nome;
            }
            let self = this;
            // get('content/'+this.bloco.id).then(function (response) {
            //     self.showContent = true;
            //     self.items = window.siteconfig.result.data.redesocial;
                self.items = this.$store.getters['getSiteContent'].result.data.redesocial;
            // });
        },
        methods: {
            getIcon(item) {
                let currentIcon = '';
                this.icons.forEach(function (value) {
                    if (value.type === item.type) {
                        currentIcon = value.icon;
                    }
                });
                return 'fab '+currentIcon;
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/home/SocialNetworksList.vue